import { render, staticRenderFns } from "./Page-Compendio.vue?vue&type=template&id=259dcfcc&scoped=true"
import script from "./Page-Compendio.vue?vue&type=script&lang=js"
export * from "./Page-Compendio.vue?vue&type=script&lang=js"
import style0 from "./Page-Compendio.vue?vue&type=style&index=0&id=259dcfcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "259dcfcc",
  null
  
)

export default component.exports